if (!customElements.get('form-validate')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) throw new Error('Form element does not exist');
    }

    toggleErrorMessage(input, field) {
      const errorMessageWrapper =
        field.querySelector('[data-message]');
      errorMessageWrapper.parentElement.classList.toggle(
        'has-error',
        !input.validity.valid
      );

      if (input.validity.valid) {
        errorMessageWrapper.hidden = true;
        errorMessageWrapper.removeAttribute('aria-hidden');
        errorMessageWrapper.textContent = '';
        input.removeAttribute('aria-describedby');
        return;
      }

      let errorMessage = input.validationMessage;
      if (input.type === 'email') {
        errorMessage = window.validationStrings.invalidEmail;
      } else if (input.validity.valueMissing && input.dataset.errorValueMissing) {
        errorMessage = input.dataset.errorValueMissing;
      }

      // Unhide first so the element enters the accessibility tree, then set
      // text in the next tick so role="alert" fires a mutation announcement.
      errorMessageWrapper.hidden = false;
      errorMessageWrapper.removeAttribute('aria-hidden');
      if (errorMessageWrapper.id) {
        input.setAttribute('aria-describedby', errorMessageWrapper.id);
      }
      errorMessageWrapper.textContent = '';
      setTimeout(() => {
        errorMessageWrapper.textContent = errorMessage;
      }, 0);
    }

    setFieldValidity(input) {
      input.setAttribute('aria-invalid', !input.validity.valid);
      const field = input.closest('[data-input-wrapper]');
      if (!field) return;
      field.classList.toggle('has-error', !input.validity.valid);
      this.toggleErrorMessage(input, field);
    }

    onSubmit(event) {
      if (!this.form.reportValidity()) {
        event.preventDefault();
      }
    }

    setHandlers() {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      for (const input of this.form.elements) {
        if (input.hasAttribute('data-no-validate')) continue;

        ['input', 'blur', 'change', 'invalid'].forEach(eventName => {
          input.addEventListener(
            eventName,
            this.setInputHandler.bind(this)
          );
        });
      }
    }

    setInputHandler(event) {
      if (event.type === 'invalid') {
        event.preventDefault();
      }

      this.setFieldValidity(event.target);
    }

    connectedCallback() {
      this.setHandlers();
      // Server-rendered role="alert" blocks are not announced on page load
      // because screen readers only react to mutations, not initial HTML.
      // Programmatic focus makes the SR read the error naturally.
      const serverError = this.querySelector('[role="alert"]:not([data-message])');
      if (serverError && serverError.textContent.trim()) {
        serverError.setAttribute('tabindex', '-1');
        serverError.focus();
      }
    }
  }

  customElements.define('form-validate', FormValidation);
}
